<template>
  <form @submit="onSubmit">
    <div class="flex gap-1">
      <VcInput
        v-model="width"
        class="mb-4 w-1/2"
        type="number"
        required
        :message="errors.width"
        :error="!!errors.width"
        :maxlength="64"
      />
      <VcInput
        v-model="height"
        class="mb-4 w-1/2"
        type="number"
        required
        :message="errors.height"
        :error="!!errors.height"
        :maxlength="64"
      />
    </div>

    <VcButton type="submit" class="w-full mb-2" :disabled="!meta.valid || meta.pending">
      {{ $t("pages.product.downloads.download_file") }}
    </VcButton>
  </form>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/yup";
import { useForm, useField } from "vee-validate";
import { object, number } from "yup";
import { useResizeImage } from "@/shared/catalog";
import { downloadFileWithNewClient } from "@/shared/files";

const props = defineProps<{
  assetUrl: string;
  name: string;
}>();

const { fetchResizeImage } = useResizeImage();

const validationSchema = toTypedSchema(
  object({
    width: number().required(),
    height: number().required(),
  }),
);

const { errors, meta, handleSubmit } = useForm({
  validationSchema,
  initialValues: {
    width: 0,
    height: 0,
  },
});

const { value: width } = useField<number>("width");
const { value: height } = useField<number>("height");

const onSubmit = handleSubmit(async (data) => {
  const resizeData = {
    blobUrl: props.assetUrl,
    width: data.width,
    height: data.height,
    maintainAspectRatio: true,
  };

  const response = await fetchResizeImage(resizeData);

  if (response && response.blobUrl) {
    void downloadFileWithNewClient(response.blobUrl, props.name);
  }
});
</script>
